<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid vehicle-info">
        <!--begin::Portlet-->
        <div class="kt-portlet">
            <div class="kt-portlet__head no-border-radius">
                <div class="kt-portlet__head-label">
                </div>
                <div class="kt-portlet__head-toolbar">
                    <app-button type="secondary" @handleClick="back">
                        <i class="glyphicons glyphicons-arrow-left"></i>{{ $t('AppVehicleInfo.Voltar') }}
                    </app-button>
                </div>
            </div>
            <div class="vehicle-info__grid">
                <!-- Coluna 1: imagem + ações -->
                <div class="vehicle-info__col">
                    <div class="v-card v-card--hero">
                        <Skeleton v-show="loading" width="100%" height="100%" borderRadius="14px"/>
                        <div v-show="!loading" class="hero">
                            <div class="hero__name">{{ vehicle.identification || 'N/D' }}</div>
                            <img class="hero__img" alt="modelo" :src="modelImage"
                                 @load="onImageLoad"
                                 onerror="this.src = 'https://static.iotag.com.br/vehicles/vehicle_512.png'">
                            <div v-if="vehicleStatus" class="hero__status">
                                {{ vehicleStatus.name }}
                                <span class="pi pi-question-circle help-style" v-if="vehicleStatus.info"
                                      v-tooltip="vehicleStatus.info"/>
                            </div>
                        </div>
                    </div>
                    <div class="vehicle-info__actions">
                        <template v-if="loading">
                            <Skeleton height="3.4rem" borderRadius="10px"/>
                            <Skeleton height="3.4rem" borderRadius="10px"/>
                        </template>
                        <template v-else>
                            <app-button type="secondary" class="vehicle-info__action"
                                        @handleClick="handleAvailability">
                                {{ vehicleAvailable ? $t('AppVehicleInfo.Tirar de operação') : $t('AppVehicleInfo.Colocar em operação') }}
                            </app-button>
                            <app-button type="danger" class="vehicle-info__action" @handleClick="handleRemove">
                                {{ $t('AppVehicleInfo.Remover') }}
                            </app-button>
                        </template>
                    </div>
                </div>

                <!-- Coluna 2: informações gerais -->
                <div class="vehicle-info__col">
                    <div class="v-card v-card--fill">
                        <Skeleton v-if="loading" width="100%" height="100%" borderRadius="14px"/>
                        <app-vehicle-info-general v-else :vehicle="vehicle" :vehicle-manufacturer="vehicleManufacturer"
                                                  :processing="processingFile" :vehicle-model="vehicleModel"
                                                  :models="models" :manufacturers="manufacturers"
                                                  @getModels="getModels" @requestSaveVehicle="requestSaveVehicle"/>
                    </div>
                </div>

                <!-- Coluna 3: contato + implementos + frente -->
                <div class="vehicle-info__col">
                    <div class="v-card">
                        <Skeleton v-if="loading" width="100%" height="8rem" borderRadius="14px"/>
                        <app-vehicle-info-last-contact v-else :vehicle="vehicle"/>
                    </div>
                    <div class="v-card" v-if="hasFeatureEnabled('ORGANIZATION_IMPLEMENTS')">
                        <Skeleton v-show="loading" width="100%" height="8rem" borderRadius="14px"/>
                        <app-vehicle-info-implements v-show="!loading" ref="vehicleInfoImplements"
                                                     :vehicle="vehicle" :vehicleImplements="vehicleImplements"
                                                     :organizationImplements="organizationImplements"
                                                     @linkImplements="linkImplements"/>
                    </div>
                    <div class="v-card" v-if="hasFeatureEnabled('MANAGEMENT_VEHICLES_GROUP')">
                        <Skeleton v-show="loading" width="100%" height="8rem" borderRadius="14px"/>
                        <AppVehicleInfoVehiclesGroup v-show="!loading" ref="vehicleInfoGroups" :vehicle="vehicle"
                                                     :organization-vehicles-groups="vehiclesGroups"
                                                     :vehicle-vehicles-group="vehiclesGroup"
                                                     @associateVehiclesGroup="associateVehiclesGroup"/>
                    </div>
                </div>
            </div>
        </div>

        <Dialog :visible.sync="showConfirmDeleteDialog" :modal="true"
                :contentStyle="{overflow: 'visible', width: '450px'}">
            <template #header>
                <div style="font-size: larger; font-weight: bold" class="pl-3">
                    <span>{{$t('AppVehicleInfo.Tem certeza que deseja remover o veículo')}}</span>
                </div>
            </template>
            <div class="pl-3"/>
            <template #footer>
                <Button :label="$t('AppVehicleInfo.Não')" @click="showConfirmDeleteDialog = false" class="p-button-secondary"/>
                <Button :label="$t('AppVehicleInfo.Sim')" @click="removeVehicle" class="p-button-info"/>
            </template>
        </Dialog>

        <Dialog :visible.sync="showConfirmSaveDialog" :modal="true" :closeOnEscape="false" :closable="false">
            <template #header>
                <div style="font-size: larger; font-weight: bold" class="pl-3">
                    <div>{{$t('AppVehicleInfo.Tem certeza que deseja salvar essa configuração?')}}</div>

                    <div>{{$t('AppVehicleInfo.Caso haja um dispositivo atrelado, pode demorar um tempo até a configuração ser aplicada')}}</div>
                </div>
            </template>
            <div class="pl-3"/>
            <template #footer>
                <Button :label="$t('AppVehicleInfo.Não')" @click="showConfirmSaveDialog = false" class="p-button-secondary"/>
                <Button :label="$t('AppVehicleInfo.Sim')" @click="saveVehicle" class="p-button-info"/>
            </template>
        </Dialog>

    </div>
</template>

<script>

import {mapGetters} from 'vuex';
import {router} from '@/router'

import AppVehiclesForm from "./AppVehiclesForm";
import AppButton from "../../common/AppButton";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Skeleton from "primevue/skeleton";
import Tooltip from "primevue/tooltip";

import VehiclesService from "@/services/VehiclesService";
import MissionService from "@/services/MissionService";
import VehiclesGroupService from "@/services/VehiclesGroupService";
import hasFeatureEnabled from "@/mixins/OrganizationFeatureFlagsMixin";
import VehiclesManufacturersService from "@/services/VehiclesManufacturersService";
import ActivitiesService from "@/services/ActivitiesService";
import AppVehicleInfoLastContact from "@/components/views/vehicles/AppVehicleInfoLastContact";
import AppVehicleInfoGeneral from "@/components/views/vehicles/AppVehicleInfoGeneral";
import AppVehicleInfoImplements from "@/components/views/vehicles/AppVehicleInfoImplements";
import AppVehicleInfoVehiclesGroup from "@/components/views/vehicles/AppVehicleInfoVehiclesGroup";
import {VEHICLES_TYPES} from "@/constants/VehiclesConstants";
import ImplementsService from "@/services/ImplementsService";

export default {
    mixins: [hasFeatureEnabled],
    mounted() {
        this.vehiclesService = new VehiclesService();
        this.missionService = new MissionService();
        this.vehiclesManufacturersService = new VehiclesManufacturersService();
        this.activitiesService = new ActivitiesService();
        this.implementsService = new ImplementsService();
        this.vehiclesGroupService = new VehiclesGroupService();

        if (!this.$route.params.id) {
            this.exitPageOnError()
            return
        }

        this.loading = true;
        this.loadVehicleData();
    },
    data() {
        return {
            loading: false,
            isLeaving: false,
            vehiclesService: null,
            missionService: null,
            vehiclesManufacturersService: null,
            vehiclesGroupService: null,
            activitiesService: null,
            vehicleId: this.$route.params.id,
            vehicle: {},
            vehicleManufacturer: null,
            vehicleModel: null,
            vehiclesGroup: null,
            modelImage: null,
            isNewImage: false,
            vehiclesGroups: [],
            manufacturers: [],
            models: [],
            vehicleConfig: {},
            processingFile: null,
            vehicleAvailable: true,
            vehicleActivity: {
                activity: null,
                workingWidth: null
            },
            activities: [],
            showConfirmDeleteDialog: false,
            showConfirmSaveDialog: false,
            vehicleStatus: null,
            vehicleTypes: VEHICLES_TYPES,
            newConfigData: null,
            newConfigParams: null,
            vehicleStatuses: {
                outOfOperation: {
                    name: this.$t('AppVehicleInfo.Fora de operação')
                },
                active: {
                    name: this.$t('AppVehicleInfo.Em operação ativo'),
                    info: this.$t('AppVehicleInfo.Conectado nos útlimos três dias')
                },
                inactive: {
                    name: this.$t('AppVehicleInfo.Em operação inativo'),
                    info: this.$t('AppVehicleInfo.Sem conexão por mais de três dias')
                },
                disconnected: {
                    name: this.$t('AppVehicleInfo.Desconectado'),
                    info: this.$t('AppVehicleInfo.Sem dispositivo no veículo')
                }
            },
            vehicleImplements: [],
            organizationImplements: [],
            implementsService: null
        }
    },
    components: {
        AppVehicleInfoGeneral,
        AppVehicleInfoLastContact,
        AppVehiclesForm,
        AppVehicleInfoImplements,
        AppVehicleInfoVehiclesGroup,
        AppButton,
        InputText,
        Dropdown,
        Dialog,
        Button,
        Skeleton,
        Tooltip
    },
    directives: {
        'tooltip': Tooltip
    },
    methods: {
        loadVehicleData() {
            Promise.all([
                this.getManufacturers(),
                this.getVehicleDetails()
            ]).then(() => {
                this.setManufacturer();
            }).catch(() => {
            })
        },
        getManufacturers() {
            return this.vehiclesManufacturersService.getManufacturers()
                .then((response) => {
                    this.manufacturers = response.sort((a, b) => a.name.localeCompare(b.name))
                }).catch((error) => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehicleInfo.Não foi possivel recuperar a lista de fabricantes'),
                        life: 5000
                    });
                    this.back();
                    throw error;
                })
        },
        getVehicleDetails() {
            return this.vehiclesService.getVehicleDetails(this.vehicleId)
                .then((response) => {
                    this.vehicle = response;
                    this.vehicleAvailable = !response.unavailability_date
                    this.setVehicleStatus();
                    if (this.hasFeatureEnabled('ORGANIZATION_IMPLEMENTS')) {
                        this.getOrgImplements(this.vehicle.organization_id);
                    }
                    if (this.hasFeatureEnabled('MANAGEMENT_VEHICLES_GROUP')) {
                        this.getOrganizationVehiclesGroup(this.vehicle.organization_id);
                    }
                    if (this.vehicle.device_id) {
                        this.getConfigFiles();
                    }
                }).catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppVehicleInfo.Não foi possível recuperar as informações do veículo'),
                            life: 5000
                        });
                        this.back()
                        throw error;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehicleInfo.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
                    this.back()
                    throw error;
                })
        },
        getOrgImplements(orgId) {
            this.implementsService.getImplementsByOrgV3(orgId).then((response) => {
                this.organizationImplements = response.filter(implement => (!implement.vid || implement.vid === this.vehicle.id));
                this.vehicleImplements = response.filter(implement => implement.vid === this.vehicle.id);
            }).catch((error) => {
                console.log(error);
                this.back()
            })
        },
        getOrganizationVehiclesGroup(orgId) {
            this.vehiclesGroupService.getOrganizationsGroups(orgId)
                .then((response) => {
                    this.vehiclesGroups = response;
                    this.setVehicleGroup();
                })
                .catch(() => {
                    this.back();
                })
        },
        setVehicleGroup() {
            if (!this.vehicle.vehicles_group_id) {
                this.vehiclesGroup = null;
                return;
            }

            let foundGroup = this.vehiclesGroups.find((group) => group.id === this.vehicle.vehicles_group_id);
            if (!foundGroup) {
                foundGroup = {
                    id: this.vehicle.vehicles_group_id,
                    name: this.vehicle.vehicles_group_name
                }
                this.vehiclesGroups.push(foundGroup);
            }

            this.vehiclesGroup = foundGroup;
        },
        setVehicleStatus() {
            if (!this.vehicle.device_id) {
                this.vehicleStatus = this.vehicleStatuses.disconnected
                return
            }

            if (!this.vehicleAvailable) {
                this.vehicleStatus = this.vehicleStatuses.outOfOperation
                return
            }

            if (this.isVehicleActive()) {
                this.vehicleStatus = this.vehicleStatuses.active
                return
            }

            this.vehicleStatus = this.vehicleStatuses.inactive
        },
        isVehicleActive() {
            let MAX_HOURS_NO_CONTACT = (3 * 24 * 3600)
            let noContact = Math.floor(Date.now() / 1000) - this.vehicle.last_contact
            return noContact <= MAX_HOURS_NO_CONTACT
        },
        getConfigFiles() {
            let params = {device_id: this.vehicle.device_id};
            this.vehiclesService.getVehicleConfigFiles(params)
                .then(response => {
                    if (response.length === 0) {
                        return
                    }
                    this.processingFile = response.sort((a, b) => b.created_date - a.created_date)[0]
                    this.getConfigFile()
                }).catch((error) => {
                if (!error.response || error.response.status !== 403) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehicleInfo.Não foi possível recuperar as informações do veículo'),
                        life: 5000
                    });
                    this.back()
                    return;
                }
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppVehicleInfo.Você não tem acesso a esta funcionalidade'),
                    life: 5000
                });

                this.back()
            })
        },
        getConfigFile() {
            let params = {device_id: this.vehicle.device_id};
            this.vehiclesService.getVehicleConfig(params)
                .then(response => {
                    this.vehicleConfig = response
                }).catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppVehicleInfo.Não foi possível recuperar as informações do veículo'),
                            life: 5000
                        });
                        this.back()
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehicleInfo.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });

                    this.back()
                })
        },
        setManufacturer() {
            let manufacturerFoundInList = this.manufacturers.find(obj => obj.id === this.vehicle.manufacturer_id)

            if (!manufacturerFoundInList) {
                this.modelImage = 'https://static.iotag.com.br/vehicles/vehicle_512.png'
                return
            }

            this.vehicleManufacturer = manufacturerFoundInList
            this.getModels(this.vehicleManufacturer.id, false)
        },
        getModels(manufacturerId, isEditing) {
            this.vehiclesService.getModelsByManufacturer(manufacturerId)
                .then((response) => {
                    this.models = response.models.sort((a, b) => a.name.localeCompare(b.name))
                    if (isEditing) {
                        return
                    }
                    this.setVehicleModel()
                }).catch(() => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Não foi possivel recuperar a lista de modelos',
                    life: 5000
                });
                this.back()
            })
        },
        setVehicleModel() {
            let modelFoundInList = this.models.find(obj => obj.id === this.vehicle.model_id)

            if (!modelFoundInList) {
                this.modelImage = 'https://static.iotag.com.br/vehicles/vehicle_512.png'
                return
            }

            this.vehicleModel = modelFoundInList
            this.setModelImage()
        },
        setModelImage() {
            let newImageSrc = `https://static.iotag.com.br/vehicles/${this.vehicleModel.id}.png`
            this.isNewImage = newImageSrc !== this.modelImage
            this.modelImage = newImageSrc
        },
        requestSaveVehicle(params, data) {
            this.newConfigData = data;
            this.newConfigParams = params;
            this.showConfirmSaveDialog = true;
        },
        saveVehicle() {
            this.loading = true;
            this.modelImage = null;
            this.showConfirmSaveDialog = false;

            if (!this.vehicle.device_id) {
                let data = {
                    identification: this.newConfigData._752,
                    model_id: this.newConfigData._030,
                    year: this.newConfigData._128,
                    maintenance_timespan: this.newConfigData.maintenanceTimespan
                }
                this.vehiclesService.patchV3(this.vehicleId, data)
                    .then(() => {
                        this.$toast.add({
                            severity: 'success',
                            summary: this.$t('AppVehicleInfo.Veículo atualizado com sucesso'),
                            life: 5000
                        });
                        this.getVehicleDetails()
                    }).catch((error) => {
                        if (!error.response || error.response.status !== 403) {
                            this.$toast.add({
                                severity: 'error',
                                summary: this.$t('AppVehicleInfo.Não foi possível atualizar o veículo'),
                                life: 5000
                            });
                            this.back();
                            return;
                        }
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppVehicleInfo.Você não tem acesso a esta funcionalidade'),
                            life: 5000
                        });
                        this.back();
                 })
                return;
            }
            this.vehiclesService.sendVehicleConfigSyn(this.newConfigData, this.newConfigParams)
                .then(() => {
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppVehicleInfo.Veículo atualizado com sucesso'),
                        life: 5000
                    });
                    this.getVehicleDetails()
                }).catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppVehicleInfo.Não foi possível atualizar o veículo'),
                            life: 5000
                        });
                        this.back();
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehicleInfo.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
                    this.back();
                })
        },
        exitPageOnError() {
            this.$toast.add({
                severity: 'error',
                summary: this.$t('AppVehicleInfo.Não foi possivel recuperar as informações do veículo'),
                life: 5000
            });
            this.back()
        },
        back() {
            if (this.isLeaving) {
                return;
            }
            this.isLeaving = true;
            router.go(-1);
        },
        handleAvailability() {
            this.loading = true
            if (this.vehicleAvailable) {
                this.makeVehicleUnavailable()
                return
            }

            this.makeVehicleAvailable()
        },
        makeVehicleUnavailable() {
            this.modelImage = null;
            this.vehiclesService.makeUnavailable(this.vehicleId)
                .then(() => {
                    this.vehicleAvailable = false
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppVehicleInfo.Veículo configurado como Fora de operação'),
                        life: 5000
                    });
                }).catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppVehicleInfo.Não foi possível atualizar o veículo'),
                            life: 5000
                        });
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehicleInfo.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
            }).finally(() => {
                this.getVehicleDetails();
            })
        },
        makeVehicleAvailable() {
            this.modelImage = null;
            this.vehiclesService.makeAvailable(this.vehicleId)
                .then(() => {
                    this.vehicleAvailable = true
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppVehicleInfo.Veículo configurado como Em operação'),
                        life: 5000
                    });
                    this.getVehicleDetails()
                }).catch((error) => {
                if (!error.response || error.response.status !== 403) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehicleInfo.Não foi possível atualizar o veículo'),
                        life: 5000
                    });
                    return;
                }
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppVehicleInfo.Você não tem acesso a esta funcionalidade'),
                    life: 5000
                });
            }).finally(() => {
                this.getVehicleDetails();
            })
        },
        handleRemove() {
            this.showConfirmDeleteDialog = true
        },
        removeVehicle() {
            this.vehiclesService.removeVehicle(this.vehicleId)
                .then(() => {
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppVehicleInfo.Veículo removido com sucesso'),
                        life: 5000
                    });
                    this.back()
                }).catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppVehicleInfo.Não foi possível atualizar o veículo'),
                            life: 5000
                        });
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehicleInfo.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
            }).finally(() => {
                this.showConfirmDeleteDialog = false
            })
        },
        onImageLoad() {
            this.loading = false
        },
        linkImplements(data) {
            let obj = {
                vid: this.vehicle.id,
                implement_ids: data.map(implement => implement.id)
            }
            this.implementsService.saveUserDeviceProfile(obj).then((response) => {
                this.$toast.add({
                    severity: 'success',
                    summary: this.$t('AppVehicleInfo.Vínculo salvo com sucesso'),
                    life: 5000
                });
                this.back()
            }).catch((error) => {
                if (!error.response || error.response.status !== 403) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehicleInfo.Não foi possível atualizar o veículo'),
                        life: 5000
                    });
                    return;
                }
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppVehicleInfo.Você não tem acesso a esta funcionalidade'),
                    life: 5000
                });
                this.back()
            }).finally(() => {
                this.getVehicleDetails();
            })
        },
        associateVehiclesGroup(vehiclesGroup) {
            this.vehiclesService.associateVehiclesGroup(this.vehicle.id, vehiclesGroup?.id)
                .then(() => {
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppVehicleInfo.Frente de trabalho associada com sucesso'),
                        life: 5000
                    });
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehicleInfo.Não foi possível associar o veículo à frente de trabalho'),
                        life: 5000
                    });
                })
        }
    },
    computed: {
        ...mapGetters([
            'getCurrentOrganization'
        ])
    }
}
</script>

<style scoped>

.vehicle-info {
    color: grey;
}

.vehicle-info__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding: 20px;
    align-items: start;
}

.vehicle-info__col {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
}

.v-card {
    background: #fff;
    border: 1px solid #e8ecee;
    border-radius: 14px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, .06);
}

.v-card--fill {
    height: 100%;
}

.v-card--hero {
    min-height: 28rem;
    display: flex;
}

/* hero (model image) card */
.hero {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    padding: 22px 18px;
}

.hero__name {
    font-size: 1.4rem;
    font-weight: 600;
    color: #3a3a3a;
}

.hero__img {
    max-height: 250px;
    max-width: 100%;
    object-fit: contain;
    margin: 14px 0;
}

.hero__status {
    font-size: 1.2rem;
    color: grey;
}

/* action buttons */
.vehicle-info__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
}

.vehicle-info__action {
    width: 100%;
    height: 3.4rem;
    border-radius: 10px;
    font-size: 1rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
}

/* stack columns on smaller screens */
@media (max-width: 1200px) {
    .vehicle-info__grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 576px) {
    .vehicle-info__actions {
        grid-template-columns: 1fr;
    }
}

</style>
